module.exports = __webpack_public_path__ + "img/exclamation-diamond.24dbaabb.svg";